import React from 'react';
import { Settings } from 'lucide-react';
import { ProfileSettings } from '../components/profile/ProfileSettings';
import { useProfile } from '../hooks/auth/useProfile';

export function SettingsPage() {
  const { profile } = useProfile();

  return (
    <div className="min-h-screen bg-background-dark py-8">
      <div className="max-w-4xl mx-auto px-3 sm:px-4">
        <div className="flex items-center space-x-2 mb-6">
          <Settings className="h-5 w-5 text-accent-green" />
          <h1 className="text-xl font-bold text-gray-100">Settings</h1>
        </div>
        <ProfileSettings profile={profile} />
      </div>
    </div>
  );
}